import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
    formControlAutoComplete: {
        minWidth: "100%",
        margin: "10px"
    },
    formControlAutoCompleteAuswahl:{
        minWidth: "100%",
    },
    formControl: {
        minWidth: "100%",
        marginBottom: "5px",
    },
    paper: {
        padding: theme.spacing(2),
        textAlign: 'center',
        color: theme.palette.text.secondary,
        marginTop: "10px", 
        //marginLeft: "24px", 
        //marginRight: "24px", 
        marginBottom: "10px",
    },
    buttonRight: {
        marginLeft: theme.spacing(1),
        float: "right"
    },
    buttonLeft: {
        marginRight: theme.spacing(1),
        float: "right"
    },
    input: {
        padding: "5px",
    },
    accordionSummary: {
        color: theme.palette.grey[600],
    },
    accordionSummaryDisabled: {
        backgroundColor: theme.palette.grey[400],
        color: theme.palette.grey[800],
        "& .MuiIconButton-label": {
            color: theme.palette.grey[600],
            borderColor: theme.palette.grey[600]
        }
    },
    exportSectionStyle: {
        height: 30,
        padding: theme.spacing(1),
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        backgroundColor: theme.palette.grey[400],
         "&:hover": {
             backgroundColor: theme.palette.grey[600],
        }
    },
    divider: {
        margin: theme.spacing(2, 0),
    },
    heightScrolledTable:{
        maxHeight: "300px",
    },
    justifyItems:{
        alignItems:'center',
    },
}), {index: 1});
